import Icon from 'vue-awesome/components/Icon'

Icon.register({
  offline_bolt_rounded: {
    paths: [
      {
        d: 'M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zm-.52 15.86v-4.14H8.82c-.37 0-.62-.4-.44-.73l3.68-7.17c.23-.47.94-.3.94.23v4.19h2.54c.37 0 .61.39.45.72l-3.56 7.12c-.24.48-.95.31-.95-.22z'
      }
    ],
    width: '24',
    height: '24'
  }
})
